var __jsx = React.createElement;
import React from 'react';
import Typography from "@app/components/atoms/Typography";
import moment from 'moment';
import { jsx as _jsx } from "react/jsx-runtime";
export var dateTimeVisibilityHandler = function dateTimeVisibilityHandler(opportunity, variant, color) {
  var _opportunity$time_vis4, _opportunity$time_vis5;
  if (opportunity.start_date && !opportunity.end_date) {
    var _opportunity$time_vis;
    if ((_opportunity$time_vis = opportunity.time_visibility) !== null && _opportunity$time_vis !== void 0 && _opportunity$time_vis.start_time) {
      return /*#__PURE__*/_jsx(Typography, {
        variant: variant,
        color: color,
        gutterBottom: true,
        children: "".concat(moment(opportunity.start_date).format('D MMM YYYY HH:mm '))
      });
    }
    return /*#__PURE__*/_jsx(Typography, {
      variant: variant,
      color: color,
      gutterBottom: true,
      children: "".concat(moment(opportunity.start_date).format('D MMM YYYY'))
    });
  }
  if (moment(opportunity.start_date).date() === moment(opportunity.end_date).date()) {
    return /*#__PURE__*/_jsx(Typography, {
      variant: variant,
      color: color,
      gutterBottom: true,
      children: "".concat(moment(opportunity.start_date).format('D MMM YYYY'), " ").concat(moment(opportunity.start_date).format('HH:mm'), "-").concat(moment(opportunity.end_date).format('HH:mm'))
    });
  }
  if (moment(opportunity.start_date).month() === moment(opportunity.end_date).month()) {
    var _opportunity$time_vis2;
    if (!((_opportunity$time_vis2 = opportunity.time_visibility) !== null && _opportunity$time_vis2 !== void 0 && _opportunity$time_vis2.start_time)) {
      return /*#__PURE__*/_jsx(Typography, {
        variant: variant,
        color: color,
        gutterBottom: true,
        children: "".concat(moment(opportunity.start_date).format('D'), " - ").concat(moment(opportunity.end_date).format('D MMM YYYY'), " ")
      });
    }
    return /*#__PURE__*/_jsx(Typography, {
      variant: variant,
      color: color,
      gutterBottom: true,
      children: "".concat(moment(opportunity.start_date).format('D MMM HH:mm'), " - ").concat(moment(opportunity.end_date).format('D MMM HH:mm YYYY'), " ")
    });
  }
  if (moment(opportunity.start_date).year() !== moment(opportunity.end_date).year()) {
    var _opportunity$time_vis3;
    if ((_opportunity$time_vis3 = opportunity.time_visibility) !== null && _opportunity$time_vis3 !== void 0 && _opportunity$time_vis3.start_time) {
      return /*#__PURE__*/_jsx(Typography, {
        variant: variant,
        color: color,
        gutterBottom: true,
        children: "".concat(moment(opportunity.start_date).format('D MMM YYYY HH:mm'), " - ").concat(moment(opportunity.end_date).format('D MMM YYYY HH:mm'), " ")
      });
    }
    return /*#__PURE__*/_jsx(Typography, {
      variant: variant,
      color: color,
      gutterBottom: true,
      children: "".concat(moment(opportunity.start_date).format('D MMM YYYY'), " - ").concat(moment(opportunity.end_date).format('D MMM YYYY'), " ")
    });
  }
  if ((_opportunity$time_vis4 = opportunity.time_visibility) !== null && _opportunity$time_vis4 !== void 0 && _opportunity$time_vis4.start_time || (_opportunity$time_vis5 = opportunity.time_visibility) !== null && _opportunity$time_vis5 !== void 0 && _opportunity$time_vis5.end_time) {
    return /*#__PURE__*/_jsx(Typography, {
      variant: variant,
      color: color,
      gutterBottom: true,
      children: "".concat(moment(opportunity.start_date).format('D MMM YYYY HH:mm '), " - ").concat(moment(opportunity.end_date).format('D MMM YYYY HH:mm'))
    });
  }
  return /*#__PURE__*/_jsx(Typography, {
    variant: variant,
    color: color,
    gutterBottom: true,
    children: "".concat(moment(opportunity.start_date).format('D MMM YYYY'), " - ").concat(moment(opportunity.end_date).format('D MMM YYYY '))
  });
};